import { Link, Link as RouterLink } from 'react-router-dom';
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  CardActions,
  Button,
  Typography
} from '@material-ui/core';
import moment from 'moment';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { green } from '@material-ui/core/colors';
import AddchartIcon from '@material-ui/icons/Addchart';
import helper from 'src/utils/helpers';
import { Collapse } from '@material-ui/core';
import { useState } from 'react';

//COmponents
import AddPay from 'src/materials/FullScreenPay';

const TotalCustomers = ({data}) => {
    let percentage = 0;

  let dueDates = data && data.dueDates.sort((a, b) => {return a.dueNo - b.dueNo});
  let days = 0
   let amount = 0;
  dueDates.filter(a => !a.isPaid).forEach((a, index)  => {
      if(!a.isPaid && index === 0){
        var given = moment(a.dueDate);
        var current = moment().startOf('day');
       let day = moment.duration(given.diff(current)).asDays();
        days = Number(day).toFixed(0);
        percentage = data.rateTerm === 'Weekly' ? ((7 - days) / 7) * 100 : (((15 - days) / 15) * 100);
      }

      var given = moment(a.dueDate);
      var current = moment().startOf('day');
     let day = moment.duration(given.diff(current)).asDays();
      if(!a.isPaid && day <= 0){
          amount += a.amountDue;
      }
  })



//Difference in number of days

return(
  <Card
  >

    <CardContent>
    <Typography
              color="primary"
              variant="h6"
            >
            Loan Payable
            </Typography>
            <Box  className="d-flex">
            <Box  className="w-100" sx={{
                   m: 1,   
                   alignItems: 'center'
              }}>
                    <Typography
              color="textSecondary"
              variant="caption"
            >
             Loan Amount
            </Typography>
            
              <Typography
              sx={{
                mr: 1
              }}
              color="textPrimary"
              variant="h5"
            >
             {helper.toCurrency(data && data.loanAmount)}
            </Typography>
            <Typography
              color="textSecondary"
              variant="caption"
              className="mt-3"
            >
            Balance
            </Typography>
              <Typography
              sx={{
                mr: 1
              }}
              color="textPrimary"
              variant="h5"
            >
             {helper.toCurrency(data && (data.loanAmount - data.totalCollected))}
            </Typography>
              </Box>
              
<Box className="w-100 m-auto">
<div className="center-element m-auto" style={{ width: 75, height: 75 }}>
<CircularProgressbar value={percentage} text={`${days} days`} />
</div>
<Box  className="text-center" sx={{
                   m: 1,   
                   alignItems: 'center'
              }}>
                    <Typography
              className="text-info"
              variant="caption"
            >
                Amount Due
            </Typography>
              <Typography
              sx={{
                mr: 1
              }}
              variant="h5"
              color="secondary"
            >
             {helper.toCurrency(amount)}
            </Typography>
          
              </Box>

</Box>
</Box>
    </CardContent>
    <CardActions className="center-element">
        <AddPay type="pay"/>
      </CardActions>
  </Card>
);
}
export default TotalCustomers;
